<wl-progressive-form-step-wrapper
  [title]="rendering?.fields?.addressStepTitle?.value"
  [subtitle]="rendering?.fields?.addressStepSubTitle?.value"
  [formState]="formState"
  [rendering]="rendering"
  [stepNumber]="trackStep.step"
  [stepName]="trackStep.stepName"
  [submitButtonText]="rendering?.fields?.addressNextButtonText?.value"
  [submitButtonIcon]="
    rendering?.fields?.addressNextButtonIcon?.fields?.value?.value
  "
  submitButtonAutomationId="submit-address"
  [progressiveFormSelectorKey]="progressiveFormSelectorKey"
  [isReadonly]="isReadonly"
>
  <ng-template wlProgressiveFormBody>
    <wl-address-form
      [formState]="formState"
      [rendering]="rendering"
      [content]="addressFormContent"
      [trackStep]="trackStep"
      [floatingLabels]="true"
      [showAddressTypeSelector]="showAddressTypeSelector"
    ></wl-address-form>
  </ng-template>
  <ng-template wlProgressiveFormSummary>
    <div wlCSMask>
      <p class="mb-0">
        {{ formState?.value?.street }}
        {{ formState?.value?.communicationNumber
        }}{{ formState?.value?.houseNumberAddition }}
      </p>
      <p class="mb-0">
        {{ formState?.value?.postalCode }} {{ formState?.value?.city }}
      </p>
    </div>
  </ng-template>
</wl-progressive-form-step-wrapper>
